import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import { Box, FormGroup } from "@mui/material";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import "react-quill/dist/quill.snow.css";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CoreButton from "../../../../app/core/components/CoreButton/CoreButton";
import CoreButtonIcon from "../../../../app/core/components/CoreButtonIcon/CoreButtonIcon";
import CoreIconDelete from "../../../../app/core/components/CoreIconDelete/CoreIconDelete";
import CoreInputField from "../../../../app/core/components/CoreInputField/CoreInputField";
import CoreSelectObjArr from "../../../../app/core/components/CoreSelect/CoreSelectObjArr";
import CoreSpinner from "../../../../app/core/components/CoreSpinner/CoreSpinner";
import {
  useCreateNewsMutation,
  useEditNewsMutation,
  useGetProfileCategoryQuery,
  useGetSingleNewsQuery,
  useGetUploadURLQuery,
} from "../../../api/admin/gestioneNewsApi";
import { doUploadImgNews } from "../gestioneNewsSlice";
import NewsTextEditor from "../NewsEditor/NewsTextEditor";
import { extractYYYYMMDDFromISO } from "../../../../utils/functions/date-utils";
import CoreBack from "../../../../app/core/components/CoreBack/CoreBack";

const CreaNews = () => {
  const params = useParams();
  const [newNews, setNewNews] = useState({
    Title: "",
    CategoryId: null,
    Date: "",
    ImageUrl: "",
    EmploymentStatusId: "",
  });
  const [newsText, setNewsText] = useState();
  const [image, setImage] = useState({
    file: null,
    imagePreview: null,
  });

  const [validationErrors, setValidationErrors] = useState({});

  const { data: dataSingleNews, isLoading: isLoadingSingleNews } =
    useGetSingleNewsQuery(params.id, { skip: !params.id });
  const { data: dataListCategory, isLoading: isLoadingListCategory } =
    useGetProfileCategoryQuery();

  const { data: uploadURL, refetch: refetchLinkForImageUpload } =
    useGetUploadURLQuery();

  const [createNews, { isLoading: isCreateLoading }] = useCreateNewsMutation();
  const [editNews, { isLoading: isEditLoading }] = useEditNewsMutation();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (dataSingleNews && dataSingleNews.Data) {
      setNewNews({
        Id: dataSingleNews.Data.id,
        Title: dataSingleNews.Data.title,
        Status: dataSingleNews.Data.status,
        ImageUrl: dataSingleNews.Data.imageUrl,
        Date: extractYYYYMMDDFromISO(dataSingleNews.Data.date),
        EmploymentStatusId: dataSingleNews.Data.employmentStatusId || t("All"),
      });
      setNewsText(dataSingleNews.Data.text);
    }
  }, [dataSingleNews]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValidationErrors({ ...validationErrors, [name]: "" });
    setNewNews({
      ...newNews,
      [name]: value,
    });
  };

  const handleChangeText = (value) => {
    setNewsText(value);
  };

  const handleFileDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    const reader = new FileReader();
    reader.onload = () => {
      setImage((prev) => ({ ...prev, imagePreview: reader.result }));
    };
    setImage((prev) => ({ ...prev, file: file }));
    reader.readAsDataURL(file);
  };

  const uploadIMG = async () => {
    let clearURL = "";
    if (uploadURL?.Data) {
      const uploadFileUrl = uploadURL.Data;
      await dispatch(
        doUploadImgNews({
          url: uploadFileUrl,
          file: new Blob([image.file]),
          type: image.file.type,
        })
      ).then((res) => {
        if (res.payload && res.payload.Exception) {
          toast.error(res.payload.Exception);
        } else {
          refetchLinkForImageUpload();
        }
      });
      clearURL = uploadFileUrl.split("?")[0];
      setNewNews({
        ...newNews,
        ImageUrl: clearURL,
      });
    }
    return clearURL;
  };

  const handleDeleteImage = () => {
    setImage({ file: null, imagePreview: null });
    setNewNews((prev) => ({ ...prev, ImageUrl: "" }));
  };

  const handleSubmitNews = async (e) => {
    e.preventDefault();
    setValidationErrors({});
    const errors = {};
    if (!newNews.Date) errors.Date = t("FieldRequired");
    if (!newNews.EmploymentStatusId)
      errors.EmploymentStatusId = t("FieldRequired");
    if (!newNews.Title?.trim()) errors.Title = t("FieldRequired");
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }
    const imageUrl = image.file ? await uploadIMG() : "";
    const bodyDataNews = {
      ...newNews,
      Text: newsText,
      EmploymentStatusId:
        newNews.EmploymentStatusId === "Tutti"
          ? null
          : newNews.EmploymentStatusId,
      Status: 0,
      ImageUrl: imageUrl || newNews.ImageUrl,
    };

    if (!params.id) {
      createNews(bodyDataNews).then((res) => {
        if (res?.data?.Result !== 1) {
          toast.error("News non creata");
        } else {
          toast.success("News creata");
        }
        navigate(-1);
      });
    }

    if (params.id) {
      editNews(bodyDataNews)
        .then((res) => {
          if (res.data.Result !== 1) {
            toast.error(t("NewsNotUpdated"));
            return;
          }
          toast.success(t("NewsUpdated"));
          navigate(-1);
        })
        .catch(() => toast.error(t("NewsNotUpdated")));
    }
  };

  if (isLoadingSingleNews || isLoadingListCategory) return <CoreSpinner />;

  return (
    <div className="flex flex-col h-full w-full">
      <div className="flex  items-center w-full ">
        <CoreBack />
        <div className="w-11/12 flex items-center ">
          <h2 className="fw-bold">
            {params.id ? t("UpdateNews") : t("CreateNews")}
          </h2>
        </div>
      </div>

      <div className="flex flex-wrap space-x-8">
        <div className="flex lg:w-6/12 sm:mb-20" style={{ height: "auto" }}>
          <NewsTextEditor
            text={newsText}
            handleChangeText={handleChangeText}
            uploadURL={uploadURL}
          />
        </div>
        <div className="flex flex-col shadow-md rounded-md p-4 lg:w-4/12 justify-center items-center sm:mb-20 ">
          <div className="p-5">
            <h3 className="font-bold text-center">{t("InsertNewsImg")}</h3>
            <div
              style={{
                height: "250px",
                maxWidth: "400px",
              }}
            >
              {image.imagePreview || newNews.ImageUrl ? (
                <div className="flex flex-col justify-center items-center">
                  <div className="relative p-4">
                    <img
                      src={image.imagePreview || newNews.ImageUrl}
                      alt="Preview"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "250px",
                        objectFit: "cover",
                      }}
                    />
                    <CoreIconDelete onDelete={handleDeleteImage} />
                  </div>
                </div>
              ) : (
                <Dropzone
                  onDrop={handleFileDrop}
                  // accept={["image/*", ".pdf"]}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div
                      className="flex justify-center items-center"
                      {...getRootProps()}
                      style={{
                        minHeight: "auto",
                        maxWidth: "100%",
                        padding: "20px",
                        border: "1px dashed #ccc",
                        textAlign: "center",
                        cursor: "pointer",
                        marginBottom: "30px",
                      }}
                    >
                      <input {...getInputProps()} />
                      <Box display="flex" flexDirection="column">
                        <p className="text-center text-gray">{t("DropFile")}</p>
                        <CoreButtonIcon
                          icon={
                            <UploadFileRoundedIcon
                              className="text-gray"
                              sx={{ fontSize: 60 }}
                            />
                          }
                        />
                        <CoreButtonIcon
                          icon={<SearchRoundedIcon className="text-gray" />}
                          testo={t("Search")}
                          className="text-gray"
                        />
                      </Box>
                    </div>
                  )}
                </Dropzone>
              )}
            </div>
          </div>
          <FormGroup className="w-full p-5">
            <CoreInputField
              required
              label={t("Title")}
              name="Title"
              onChange={handleChange}
              value={newNews.Title}
              error={Boolean(validationErrors.Title)}
              helperText={validationErrors.Title}
            />
          </FormGroup>
          <FormGroup className="w-full p-5">
            <CoreInputField
              required
              label={t("Date")}
              name="Date"
              type="date"
              onChange={handleChange}
              value={newNews.Date}
              focused
              color="grey"
              error={Boolean(validationErrors.Date)}
              helperText={validationErrors.Date}
            />
          </FormGroup>

          <FormGroup className="w-full p-5">
            <div className="flex flex-col justify-center items-center">
              <p className="w-full font-bold text-wrap">
                A chi è rivolto l'articolo
              </p>
              <CoreSelectObjArr
                name="EmploymentStatusId"
                label={t("SelectEmployment")}
                value={newNews.EmploymentStatusId}
                items={[
                  {
                    value: "Tutti",
                    label: t("All"),
                  },
                  ...(dataListCategory?.Data.map((el) => ({
                    label: el.name,
                    value: el.id,
                  })) || []),
                ]}
                onChange={handleChange}
                error={Boolean(validationErrors.EmploymentStatusId)}
                helperText={validationErrors.EmploymentStatusId}
                required={true}
              />
            </div>
          </FormGroup>
          <div className="flex h-full justify-around items-center  ">
            <div className="py-5">
              <CoreButton
                className="btn-round"
                testo={isCreateLoading ? t("Wait") : t("Save")}
                onClick={handleSubmitNews}
                disabled={isCreateLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreaNews;
